import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { Organization } from '../../../../core/interfaces/organization';
import { NewOrganizationComponent } from "../new-organization/new-organization.component";
import { EditOrganizationComponent } from "../edit-organization/edit-organization.component";
import { OrganizationApiService } from '../../../../core/services/organization-api.service';
import { InputTextModule } from 'primeng/inputtext';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-list-organization',
  imports: [ToastModule,
    ToolbarModule,
    IconField,
    InputIcon,
    FormsModule,
    ButtonModule,
    TableModule,
    NewOrganizationComponent,
    EditOrganizationComponent,
    InputTextModule,
    BlockUIModule,
    ProgressSpinnerModule],
  templateUrl: './list-organization.component.html',
  styleUrl: './list-organization.component.scss'
})
export class ListOrganizationComponent {

  name!: string;
  blockedDocument = false;
  organizations: Organization[] = [];
  visible = false;
  editVisible = false;
  editOrganization!: Organization

  constructor(private organizationApi: OrganizationApiService) {
    this.loadOrganizations();
  }

  showDialog() {
    this.visible = true
  }
  
  showEdit(organization: Organization) {
    this.editOrganization = organization
    this.editVisible = true
  }
  

  closeEditDialog(event: any) {
    this.editVisible = false
    this.loadOrganizations()
  }
  
  closeDialog(event: any) {
    this.visible = false
    this.loadOrganizations()
  }
  
  loadOrganizations() {
    this.blockedDocument = true;
    this.organizationApi.getOrganization().subscribe({
        next: (data) => {
          this.organizations = data;
          this.blockedDocument = false;
        },
        error: () => {
          this.blockedDocument = false;
        }
      })
    
  }
  

  get filteredItems() {
    if(this.organizations) {
          return this.organizations.filter(item =>
            (!this.name || item!.name!.toLowerCase().includes(this.name.toLowerCase())) 

    ); }
    return [];
  }
}
